var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1280,
    height: 800,
    viewBox: "0 0 1280 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M1394.88,735.285s162.2-181.118,325.742-333.852S1981.486,104.075,1962.563-1.352s669.056-33.791,669.056-33.791,108.13,544.706,108.13,558.222-50.01,390.62-54.065,393.324-1000.2,13.516-1012.369,13.516-439.279-79.746-439.279-79.746l98.669-48.659Z",
    transform: "translate(-1332 -6)",
    fill: "#8cebbf"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1280_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 800
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1280_2",
    "data-name": "Web 1280 \\u2013 2",
    clipPath: "url(#clip-Web_1280_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 800,
    fill: "#c7f7eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1",
    "data-name": "Mask Group 1",
    transform: "translate(195 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M0,0H1280V800H0Z",
    fill: "#8cebbf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.58b658ed7e451987719d267df355f159.svg";
export { ForwardRef as ReactComponent };